import { configureStore } from "@reduxjs/toolkit";
import DepartmentsReducer from "./Slices/DepartmentsSlice";
import ScrollReducer from "./Slices/ScrollSlice"

const store = configureStore({
  reducer: {
    //auth: authReducer,
    departments: DepartmentsReducer,
    scroll: ScrollReducer,
  },
});
export default store;
